import React from 'react';
import PropTypes from 'prop-types';
import InputField from '../../Form/TextFields/InputField';
import Checkbox from '../../Form/Checkbox/Checkbox';
import Button from '../../Form/Buttons/Button';
import Modal from '../Modal';
import classes from './noteModal.module.scss';
import Select from '../../Form/Selects/Select/Select';
import accountHelpers from '../../../../utils/accountHelpers';

function NoteModal({
  isOpenModal, onClose, onChangeText, onChangeCheckbox, checkedValue, saveLoading,
  textValue, saveNote, selectNote, onChangeSelect, selectOption, showSelect, group, showCheckbox,
}) {
  const isPatient = accountHelpers.isInOneOfRoles(['Patient']);

  return (
    <Modal
      open={isOpenModal}
      onClose={onClose}
      className={classes.doc_modal}
    >
      <div className={classes.add_modal_wrapper}>
        <h2>Add note</h2>

        <div>
          <div className={classes.textarea_note}>
            <InputField
              onChange={(value) => onChangeText(value)}
              textareaField
              value={textValue}
            />
          </div>

          {!group && showSelect && (
          <div className={classes.select_note}>
            <Select
              label="Select Relevant Visit"
              options={selectNote}
              zIndex={31}
              currentOption={selectOption}
              onChange={(option) => onChangeSelect(option)}
              optionRenderPath="value"
            />
          </div>
          )}

          {showCheckbox && !isPatient && (
            <Checkbox
              label="Make private"
              onChange={(checked) => onChangeCheckbox(checked)}
              checked={checkedValue}
            />
          )}
        </div>

        <div className={classes.btn_wrapper}>

          <Button
            title="Cancel"
            type="button"
            onClick={onClose}
            clearButton
          />

          <Button
            title="Add note"
            type="button"
            loading={saveLoading}
            onClick={saveNote}
          />
        </div>
      </div>
    </Modal>
  );
}

NoteModal.propTypes = {
  isOpenModal: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onChangeText: PropTypes.func.isRequired,
  onChangeCheckbox: PropTypes.func,
  checkedValue: PropTypes.bool,
  showSelect: PropTypes.bool,
  showCheckbox: PropTypes.bool,
  group: PropTypes.bool,
  saveLoading: PropTypes.bool,
  textValue: PropTypes.string.isRequired,
  saveNote: PropTypes.func.isRequired,
  onChangeSelect: PropTypes.func,
  selectNote: PropTypes.array,
  selectOption: PropTypes.string,

};

NoteModal.defaultProps = {
  selectNote: [],
  onChangeSelect: () => {},
  checkedValue: false,
  showSelect: false,
  showCheckbox: true,
  group: false,
  saveLoading: false,
  onChangeCheckbox: () => {},
  selectOption: '',
};

export default NoteModal;
